import DOMPurify from 'dompurify';

// Убираем из HTML опасные вещи скрипты, подозрительные ссылки и т.п
export function sanitizeEditorHtml(html: string): string {
  return DOMPurify.sanitize(html);
}
